export const breakpoints: {
  tablet: number;
} = {
  tablet: 700,
};
